
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  DetailedCompanyInformationResponse,
  LegalInformationProvider,
  UboSuggestionResource,
} from '../models';
import {
    DetailedCompanyInformationResponseFromJSON,
    DetailedCompanyInformationResponseToJSON,
    LegalInformationProviderFromJSON,
    LegalInformationProviderToJSON,
    UboSuggestionResourceFromJSON,
    UboSuggestionResourceToJSON,
} from '../models';

export interface FetchDetailedCompanyInformationRequest {
    provider: LegalInformationProvider;
    externalId: string;
    registrationNumber: string;
    countryCode: string;
    hqRegistrationCity?: string;
}

export interface FetchUboSuggestionsRequest {
    companyId: string;
}

/**
 * 
 */
export class FreelancerLegalSearchApi extends runtime.BaseAPI {

    /**
     * Fetches detailed company information from external providers with immediate VAT validation. Returns normalized data suitable for freelancer form auto-population. Handles provider errors gracefully with appropriate fallbacks. 
     * Fetch detailed company information with VAT validation
          */
    async fetchDetailedCompanyInformationRaw(requestParameters: FetchDetailedCompanyInformationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<DetailedCompanyInformationResponse>> {
        if (requestParameters['provider'] == null) {
            throw new runtime.RequiredError(
                'provider',
                'Required parameter "provider" was null or undefined when calling fetchDetailedCompanyInformation().'
            );
        }

        if (requestParameters['externalId'] == null) {
            throw new runtime.RequiredError(
                'externalId',
                'Required parameter "externalId" was null or undefined when calling fetchDetailedCompanyInformation().'
            );
        }

        if (requestParameters['registrationNumber'] == null) {
            throw new runtime.RequiredError(
                'registrationNumber',
                'Required parameter "registrationNumber" was null or undefined when calling fetchDetailedCompanyInformation().'
            );
        }

        if (requestParameters['countryCode'] == null) {
            throw new runtime.RequiredError(
                'countryCode',
                'Required parameter "countryCode" was null or undefined when calling fetchDetailedCompanyInformation().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['provider'] != null) {
            queryParameters['provider'] = requestParameters['provider'];
        }

        if (requestParameters['externalId'] != null) {
            queryParameters['externalId'] = requestParameters['externalId'];
        }

        if (requestParameters['registrationNumber'] != null) {
            queryParameters['registrationNumber'] = requestParameters['registrationNumber'];
        }

        if (requestParameters['hqRegistrationCity'] != null) {
            queryParameters['hqRegistrationCity'] = requestParameters['hqRegistrationCity'];
        }

        if (requestParameters['countryCode'] != null) {
            queryParameters['countryCode'] = requestParameters['countryCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<DetailedCompanyInformationResponse>({
            path: `/compliance/api/freelancer/legal-information/fetch-detailed`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=DetailedCompanyInformationResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Fetches detailed company information from external providers with immediate VAT validation. Returns normalized data suitable for freelancer form auto-population. Handles provider errors gracefully with appropriate fallbacks. 
     * Fetch detailed company information with VAT validation
          */
    async fetchDetailedCompanyInformation(requestParameters: FetchDetailedCompanyInformationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<DetailedCompanyInformationResponse> {
        const response = await this.fetchDetailedCompanyInformationRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Fetches UBO (Ultimate Beneficial Owners) data for a company using its freelancer company ID. For FR companies, triggers a synchronous fetch from Pappers if not already cached. Returns UBOs with more than 25% shares as prefill suggestions. 
     * Fetch UBO suggestions for a company from Pappers
          */
    async fetchUboSuggestionsRaw(requestParameters: FetchUboSuggestionsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<UboSuggestionResource>>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling fetchUboSuggestions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<UboSuggestionResource>>({
            path: `/compliance/api/freelancer/legal-information/ubo-suggestions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(UboSuggestionResourceFromJSON);
        return response;
    }

    /**
     * Fetches UBO (Ultimate Beneficial Owners) data for a company using its freelancer company ID. For FR companies, triggers a synchronous fetch from Pappers if not already cached. Returns UBOs with more than 25% shares as prefill suggestions. 
     * Fetch UBO suggestions for a company from Pappers
          */
    async fetchUboSuggestions(requestParameters: FetchUboSuggestionsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<UboSuggestionResource>> {
        const response = await this.fetchUboSuggestionsRaw(requestParameters, initOverrides);
        return response._data;
    }

}
